import { ReactNode } from 'react';

import { ServiceLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { Bean } from '@dreryk/react-common';
import { EmptyStatePlaceholder, InteractiveTable } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../../translations';
import { WithMultipleServiceLocationController } from '../serviceLocations.types';

import { ServiceLocationsInteractiveTableSelector } from './ServiceLocationsInteractiveTableSelector';
import { useServiceLocationsInteractiveTableColumnConfigurationOptions } from './ServiceLocationsInteractiveTable.hooks';

const t = receptionServiceTranslationKeys.shared.form.components.serviceLocationsInteractiveTable.placeholder;

type ServiceLocationsInteractiveTableProps = Pick<WithMultipleServiceLocationController, 'register'> & {
   readonly header: ReactNode;
   readonly readOnly?: boolean;
};

export const ServiceLocationsInteractiveTable = (props: ServiceLocationsInteractiveTableProps): JSX.Element => {
   const columns = useServiceLocationsInteractiveTableColumnConfigurationOptions(props.readOnly);

   return (
      <InteractiveTable<ServiceLocation, Bean>
         name={'serviceLocations.value'}
         register={props.register}
         columns={columns}
         testId={'serviceLocations'}
         header={props.header}
         placeholder={<EmptyStatePlaceholder heading={t.heading} testId={'noServiceLocations'} />}
      />
   );
};

ServiceLocationsInteractiveTable.Selector = ServiceLocationsInteractiveTableSelector;
